import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { Inline, xcss } from '@atlaskit/primitives';

/**
 * Shows an icon and feature name so as to depict a feature being compared.
 */
export const FeatureRow = ({
	icon,
	name,
	keyName,
}: {
	icon: ReactNode;
	name: string;
	keyName: string;
}) => (
	<Inline key={keyName} xcss={featureLineStyles}>
		{icon}
		<TextWrapper key={`wrapper-${keyName}`}>{name}</TextWrapper>
	</Inline>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const TextWrapper = styled.div({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

const featureLineStyles = xcss({
	height: '24px',
	maxWidth: '165px',
	gap: 'space.100',
});
